"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var useStyles = core_1.makeStyles(function () {
    return core_1.createStyles({
        paperRoot: {
            borderRadius: '10px 10px 0px 0px',
        },
    });
});
var BottomDrawer = function (_a) {
    var open = _a.open, children = _a.children, onClose = _a.onClose;
    var classes = useStyles();
    return (react_1.default.createElement(core_1.Drawer, { anchor: "bottom", PaperProps: { className: classes.paperRoot }, open: open, onClose: onClose }, children));
};
exports.default = BottomDrawer;
